<div class="card" style="background-color: transparent!important;">
  <div class="content">
    <h1 class="pb-4r mt-3"><img src="assets/images/youtine-logo-white.svg" class="mx-auto" width="240px"></h1>
    <h1 class="mb-4 text-white">Login</h1>
    <form data-id="login-form">
      <div class="input-style input-style-always-active no-borders has-icon validate-field mb-5 mt-5">
        <i class="fa fa-envelope"></i>
        <input type="email"
               name="email"
               class="form-control"
               id="input-email"
               required>
        <label for="input-email" class="color-primary text-uppercase font-700 font-10">E-Mail</label>
        <i class="fa fa-times invalid color-red-dark"></i>
      </div>
      <div class="input-style input-style-always-active no-borders has-icon validate-field mb-5 mt-5">
        <i class="fa fa-lock"></i>
        <input type="password"
               name="password"
               class="form-control"
               id="input-password"
               required>
        <label for="input-password" class="color-primary text-uppercase font-700 font-10">Password</label>
        <i class="fa fa-times invalid color-red-dark"></i>
      </div>
      <div class="clearfix"></div>
      <div class="hidden" data-id="error-container">
        <p data-id="error-text" class="pl-3 pr-3 pb-3 pt-0 error-text"></p>
      </div>
      <p class="mt-1 mb-2 text-center">
        <a href="/request-password-reset">Passwort vergessen?</a>
      </p>
      <p style="text-align: center">
        <button data-id="btn-login"
                type="button"
                style="margin: auto"
                class="btn btn-l mb-3 mt-1 rounded-xs text-uppercase font-700 btn-shadow-l bg-white text-primary">Login</button>
      </p>
      <% if ( false === isFromSoi ) { %>
        <p class="mt-3 text-center text-white">
          Noch keinen Account?
        </p>
        <p class="mt-1 text-center">
          <a href="/register">Hier geht's zur Registration <i class="fa-solid fa-arrow-right"></i></a>
        </p>
      <% } %>
    </form>
  </div>
</div>
